module.exports = __webpack_public_path__ + "cd5cebdc72d8c21ae57d0bb30219c478.png";